import tenantApi from 'src/api/clients/tenant';
import { UnassignSpaceGroupFromEmployeeGroupPayload } from '../types/payload/unassign-space-group-from-employee-group.payload';

export const assignSpaceGroupsToEmployeeGroup = async (
  token: string,
  spaceGroupTokens: string[],
): Promise<void> => {
  await tenantApi.post<void>(`/employee-groups/${token}/space-groups`, {
    spaceGroupTokens,
  });
};

export const unassignSpaceGroupFromEmployeeGroup = async ({
  employeeGroupToken,
  spaceGroupToken,
  bookingsDecisions,
  bookingsDecisionsReason,
}: UnassignSpaceGroupFromEmployeeGroupPayload): Promise<void> => {
  await tenantApi.post<void>(
    `/employee-groups/${employeeGroupToken}/space-groups/${spaceGroupToken}/unassign`,
    {
      bookingsDecisions,
      bookingsDecisionsReason,
    },
  );
};
